import React, { useState, useEffect } from "react";
import axios from "axios";
import { MoveLeft, ChevronDown, EllipsisVertical, Loader } from "lucide-react";
import tata from "../../../assets/Vehicles/tata.png";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import WOIcon from "../../../assets/svg/workorder.svg";
import attachment from "../../../assets/png/attachment.png";
import "../../../Util.css";
import { getWorkOrderDetailsApi } from "../services-api.js";
import download from "../../../assets/svg/download.svg";
import StatusUpdateModal from "./status-update.js";
import { ToastContainer, Toast } from "react-bootstrap";
import { useGlobal } from "../../../GlobalContext.js";

export const WorkOrderView = () => {
  const { rolePermissionList, userType } = useGlobal();
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = location.state || {};

  useEffect(() => {
    if (id != null && id !== undefined && id !== 0) {
      getWorkOrderDetails();
    }
  }, []);

  const [workOrderDetail, setWorkOrderDetail] = useState({});

  const getWorkOrderDetails = async () => {
    try {
      const response = await getWorkOrderDetailsApi(id);

      if (response.data.success === true) {
        setWorkOrderDetail(response.data.workorder ?? {});
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };
  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  function onSuccessStatusUpdate() {
    setShowStatusUpdate(false);
    setSnackbarMessage("Status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getWorkOrderDetails();
  }

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  return (
    <>
      {showStatusUpdate && (
        <StatusUpdateModal
          workOrderDetail={workOrderDetail}
          success={onSuccessStatusUpdate}
          onHide={() => {
            setShowStatusUpdate(false);
          }}
        />
      )}
      <div className="">
        <div className=" d-flex flex-wrap justify-content-between align-items-center bg-white p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className="border p-2 rounded-circle cursor-pointer"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MoveLeft />
            </div>
            <div className="bg-half-white rounded-4 p-3">
              <img src={WOIcon} alt="WOIcon" />
            </div>
            <div>
              <p className="m-0 fs-20 fw-semibold mb-1">{workOrderDetail?.workorder_id ?? "XX XXX XXX"}</p>
              <div className="d-flex align-items-center">
                <span className="me-2 fs-14" style={{ color: "#A2A7AE" }}>
                  {workOrderDetail?.title ?? ""}
                </span>
                <span className="me-2">•</span>
                <span className="border-0 fs-12 py-1 px-4 rounded-pill fw-600">{workOrderDetail?.priority ?? "----"}</span>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center mt-3 mt-xl-0 gap-3">
            {workOrderDetail.status !== "Closed" && (
              <Button
                onClick={() => {
                  setShowStatusUpdate(true);
                }}
                className="rounded-pill py-2 px-4 fs-14 fw-500"
              >
                Update status
              </Button>
            )}
            {/* <Dropdown>
                              <Dropdown.Toggle variant="success" id="dropdown-basic" className=" bg-white border rounded-pill d-flex justify-content-between align-items-center gap-2 dpm-toggle">
                                <div className={workOrderDetail?.status === true ? "green-dot" : "red-dot"}></div>
                                <span>{workOrderDetail?.status === true ? "Active" : workOrderDetail?.status === false ? "Inactive" : "-"}</span>
                                <span className="pagination-color">
                                  <ChevronDown />
                                </span>
                              </Dropdown.Toggle>
              
                              <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                                <Dropdown.Item href="#/action-1">Active</Dropdown.Item>
                                <Dropdown.Item href="#/action-2">Inactive</Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown> */}
            {checkPermission("Work Order", "edit_permission") && workOrderDetail.status !== "InProgress" && workOrderDetail.status !== "Closed" && (
              <Button
                onClick={() => {
                  navigate("/workorder/create", { state: { id: id } });
                }}
                className="dark-purple-btn rounded-pill py-2 px-4 fs-16 fw-600"
              >
                Edit
              </Button>
            )}
            {/*  <div className="border rounded-circle p-2 cursor-pointer">
                              <EllipsisVertical />
                            </div> */}
          </div>
        </div>

        <div className="mt-3 mx-2" style={{ borderRadius: "24px", padding: "24px", backgroundColor: "#FFFFFF" }}>
          <div className="fs-16 fw-semibold" style={{ color: "#212129" }}>
            {workOrderDetail.type ?? ""} task {workOrderDetail.reference_name != null ? " - " + workOrderDetail.reference_name : ""}
          </div>
          <div className="mt-2" style={{ width: "100%", border: "1px solid #EBEBEB", borderRadius: "16px", padding: "16px", backgroundColor: "#FFFFFF" }}>
            <div className="fs-16 fw-semibold" style={{ color: "#471070" }}>
              {workOrderDetail?.title ?? ""}
            </div>
            <div className="fs-14 fw-regular" style={{ color: "#172B4D" }}>
              {workOrderDetail?.description ?? ""}
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap gap-3 overviewGraph mt-3 mx-2">
          <div className="col-xl-7 col-12">
            <div className="bg-white rounded-4 p-3">
              <div style={{ borderRadius: "16px", padding: "12px", backgroundColor: "#F8F8F8" }}>
                <div className="d-flex align-items-center gap-3">
                  <div className="rounded-4 " style={{ background: "#E8E8E8", width: "56px", height: "56px" }}>
                    <img src={tata} alt="tata" width="56px" height="56px" />
                  </div>
                  <div>
                    <p className="m-0 fs-16 fw-semibold mb-1">{workOrderDetail?.lic_no ?? "XX XXX XXX"}</p>
                    <div className="d-flex align-items-center">
                      <span className="me-2  fs-14 fw-400" style={{ color: "#A2A7AE" }}>
                        {workOrderDetail?.vehicle_name ?? "Unknown"}
                      </span>
                      <span className="me-2">•</span>
                      {workOrderDetail.year_of_make && (
                        <span style={{ background: "#F0DBFF", color: "#A2A7AE" }} className="border-0 py-1 px-4 rounded-pill  fs-12">
                          {workOrderDetail.year_of_make ?? ""}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-2 d-flex justify-content-center align-items-center" style={{ borderRadius: "100px", padding: "12px 10px ", backgroundColor: "#FFFFFF", border: "0.4px solid #EBEBEB" }}>
                  <span className="fs-13 fw-regular" style={{ color: "#8790A1" }}>
                    Vehicle identification number (VIN) :{" "}
                  </span>

                  <span className="fs-14 fw-medium" style={{ color: "#172B4D" }}>
                    {workOrderDetail?.vin ?? ""}
                  </span>
                </div>
              </div>
              <div className="mt-3">
                <p className="fs-16 fw-600 m-0" style={{ color: "#212129" }}>
                  {" "}
                  Work order information
                </p>
                <div className="table-container rounded-4 overflow-hidden my-3">
                  <table className="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td className="fs-13 fw-500" style={{ width: "180px", color: "#49494B", border: "1px solid #E8E8EA" }}>
                          Issued by
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                          {workOrderDetail?.issued_by ?? "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="fs-13 fw-500" style={{ color: "#49494B", border: "1px solid #E8E8EA" }}>
                          Assigned To
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                          {workOrderDetail?.assignee}
                        </td>
                      </tr>
                      <tr>
                        <td className="fs-13 fw-500" style={{ color: "#49494B", border: "1px solid #E8E8EA" }}>
                          Vendor
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                          {workOrderDetail?.vendor ?? "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="fs-13 fw-500" style={{ color: "#49494B", border: "1px solid #E8E8EA" }}>
                          Start Odometer
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                          {workOrderDetail?.start_odometer ?? "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="fs-13 fw-500" style={{ color: "#49494B", border: "1px solid #E8E8EA" }}>
                          Completion Odometer
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                          {workOrderDetail?.end_odometer ?? "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="fs-13 fw-500" style={{ color: "#49494B", border: "1px solid #E8E8EA" }}>
                          Labor
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                          {workOrderDetail?.labour ?? "-"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="bg-white rounded-4 p-3 pt-3">
              <p className="fs-16 fw-600 m-0" style={{ color: "#212129" }}>
                Date & Timing details
              </p>
              <div className="table-container rounded-4 overflow-hidden my-3">
                <table className="table table-borderless mb-0">
                  <tbody>
                    <tr>
                      <td className="fs-13 fw-500" style={{ width: "180px", color: "#49494B", border: "1px solid #E8E8EA" }}>
                        Issued date & Time
                      </td>
                      <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                        {workOrderDetail?.issue_date ?? "-"} {workOrderDetail?.issue_time ?? "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs-13 fw-500" style={{ color: "#49494B", border: "1px solid #E8E8EA" }}>
                        Start date & Time
                      </td>
                      <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                        {workOrderDetail?.start_date ?? "-"} {workOrderDetail?.start_time ?? "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs-13 fw-500" style={{ color: "#49494B", border: "1px solid #E8E8EA" }}>
                        End date & Time
                      </td>
                      <td className="fs-13 fw-400" style={{ color: "#172B4D", border: "1px solid #E8E8EA" }}>
                        {workOrderDetail?.end_date ?? "-"} {workOrderDetail?.end_time ?? "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mt-2 bg-white rounded-4 p-3 pt-3">
              <p className="fs-16 fw-600 m-0" style={{ color: "#212129" }}>
                Attachments - {workOrderDetail?.images?.length}
              </p>

              {workOrderDetail?.images?.length > 0 && (
                <div className="row">
                  {workOrderDetail?.images?.map((item, attachIndex) => (
                    <div style={{ width: "312px" }}>
                      <div className="d-flex align-items-center bg-white rounded-4 p-2" style={{ border: "1px solid #EBEBEB" }}>
                        <img src={attachment} alt="attachment" style={{ width: "24px", height: "24px" }} />
                        <div style={{ width: "calc(100% - 32px)", marginLeft: "8px" }}>
                          <div className="fs-13 fw-500" style={{ width: "100%", color: "#172B4D", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {item.name}
                          </div>
                          <div className="fs-12 fw-400" style={{ color: "#8790A1" }}>
                            {item.size}
                          </div>
                        </div>
                        {item.url && (
                          <div
                            onClick={() => {
                              downloadFile(item.url, item.url.split("/").pop());
                            }}
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                            }}
                          >
                            <img
                              src={download}
                              style={{
                                width: "12.8px",
                                height: "12px",
                                top: "10px",
                                left: "9.6px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
                   <strong className="mr-auto">Snackbar Title</strong>
                 </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
